import React from 'react';
import './index.scss';

import { User } from '../../store/ducks/user/types';
import Api from '../../services/api'
import logoPreta from '../../assets/Images/domakoski-preta.jpg'

// import de Componentes
import Footer from '../../components/Footer';

import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'


interface StateProps { 
  user: User;
} 

interface DispatchProps {
  doLogin(user: User): void;
}

interface OwnProps {}

type Props = StateProps & DispatchProps & OwnProps;

class RecoverSenha extends React.Component <Props> {

  api: any = null;
  state: any = null;

  constructor(props) {
    super(props);
    this.api = new Api();
    this.state = {
      isLoading: false,
      email: "",
      hasError: false,
      hasErrorTitle: "",
      hasErrorMsg: "",
    }
  }
  private async handleSubmit () {
    const self = this;
    let timeout = 5000;

    if (!self.state.email) {
      self.setState({
        hasError: true,
        hasErrorTitle: "Atenção",
        hasErrorMsg: "Email não informado para recuperação de senha",
      });
      return false;
    }

    self.setState({isLoading: true, hasError: false, hasSuccess: false});

    let param = {email: self.state.email};

    try {
      const {data} = await self.api.post('/customer/reset-senha', param);

      if ( !data.status ) {
        throw new Error(data.msg);
      } else {
        self.setState({
        hasSuccess: true,
        hasSuccessTitle: "Sucesso",
        hasSuccessMsg: `Enviamos uma senha provisória para seu e-mail.`,
      });
      }

    } catch (e) {
      console.error(e);
      self.setState({
        hasError: true,
        hasErrorTitle: "Atenção",
        hasErrorMsg: `Não foi possível recuperar senha. ${e.message}`,
      }, () => {
        setTimeout(() => self.setState({ hasError: false }), timeout)
      });

    } finally {
      self.setState({isLoading: false});
    }
  }

  render () {
    // if ((this.props.user) && (this.props.user.status === false)) {
      return (
        <>
          {/* <Header/>  */}
          
          <section className="pswd-recovery">
            <Row className="recovery-form-row">
              <Col className="recovery-form-container">
                <a href="/"> <img src={logoPreta}/> </a>
                <span className="my-4 text-center recovery-title">
                  <h1> <span className="heading-border"> Recuperação de Senha </span> </h1>
                  <p className="pswd-recovery-text">
                    Insira seu endereço de e-mail e enviaremos a você uma senha temporária.
                  </p>
                </span>

                  {
                    this.state.hasSuccess &&
                    <div className="alert alert-success my-0">
                      <strong>{this.state.hasSuccessTitle}</strong> <br/>
                      {this.state.hasSuccessMsg}
                    </div>
                  }

                  {
                    this.state.hasError &&
                    <div className="alert alert-danger my-0">
                      <strong>{this.state.hasErrorTitle}</strong> <br/>
                      {this.state.hasErrorMsg}
                    </div>
                  }

                  <Form className="recovery-form">
                    <Col>
                      <Form.Row>
                        <Form.Group as={Col} controlId="formGridEmail" className="mb-3">
                          <Form.Label> Seu Email </Form.Label>
                          <Form.Control type="email" placeholder="Email" className={`user-input input-border ${(this.state.hasError) ? 'input-error' : ''}`}
                          onChange={(event) => this.setState({email: event.target.value})}/>
                        </Form.Group>
                      </Form.Row>
                    </Col>
                  </Form>

                <span className="mb-5 text-center">
                  <input type="button" value={this.state.isLoading ? 'Recuperando senha...' : 'Recuperar'} className="d-block btn-primary-action btn-user"
                  onClick={this.handleSubmit.bind(this)} disabled={this.state.isLoading}/>
                  <a href="/login" title="Voltar para o Login" className="forgot-pswd"> Voltar </a>
                </span>
                <h3 className="mt-auto mb-4"> <span className="font-size-16"> Não tem uma conta? </span> <a href="/cadastro"> Cadastre-se </a> </h3> 

              </Col>
            </Row>
          </section>

          <Footer/>
        </>
      );
  }
}

export default RecoverSenha;